import Charts from '../../components/analysis/Charts';
import { LakeDashboard } from '../../components/analysis/LakeDashboard';
import ChartArea from '../../components/custom/ChartArea';
import Chart from "react-apexcharts";
import { BackendService } from '../../lib/BackendService';
import Loading from '../../components/custom/Loading';
import { MenuItem, Select, Dialog, DialogActions, DialogContent, DialogTitle,Button } from '@mui/material';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Clear } from '@mui/icons-material';

export class DBWsPrebookErrors extends LakeDashboard {

    static dashboardTitle() {
        return "WS prebook and book errors";
    }

    constructor(props) {
        super(props);

        this.DAYS=30;
        this.TOPS=50;
        this.dvalues=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
        this.dlabels=new Array(30).fill().map((_, index) => {
            return new Date(new Date().setDate(new Date().getDate() -this.DAYS +1 + index))
                .toLocaleDateString('it-IT')
            });


        this.topRecordsSortings=[
            { value: "Date desc", label: "Sort: Date (desc)", field: "Date" }
        ];

        let af=props.analysisField;
        if(!af) af="Quantity";

        Object.assign(this.state,{
            topRecords: null,
            showBottoms: false,
            filtersCollapsed: true,
            enableBottomFilter: false,
            analysisField: af,
            topRecordsSorting: this.topRecordsSortings[0].value
        });
    }

    filterDataToFilterLabel(key,dp) {
        if(key === "date") {          
            /*  
            let dd=new Date(dp);
            let res = Math.floor((dd-new Date()) / (1000*60*60*24))+1;
            return res;
            */
           return dp;
        } else {
            return super.filterDataToFilterLabel(key,dp);
        }
    }

    filterLabelToFilterData(key,sel) {
        if(key === "date") {
            if(("" + sel).indexOf("-")>0) {
                return sel;
            }
            let res = this.dlabels[sel-1];            
            let dateParts = res.split("/");
            let dd="" + dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
            return dd;
        } else {
            return super.filterLabelToFilterData(key,sel);
        }
    }

    setup() {
        console.log("db state",this.state);
        if(!this.state.dashboardConfiguration.FilterCharts) {
            this.state.dashboardConfiguration.FilterCharts=["Hotel","Contract","Offer","Username","Server","Operation","Error","ErrorSource"];
        }

        // Setup dashboard
        let db={
            charts: {
                date: Charts.bar("date",this.dvalues,(c) => this.clickOnChart(c)),
            }
        };
        let dlbls=this.dlabels;
        db.charts.date.options.xaxis.labels={
            formatter: function (value) {
                return dlbls[parseInt(value)-1];
            }
        };
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Configuring filter chart '" + fc + "'");
            db.charts[fc]=Charts.donut(fc,(c) => this.clickOnChart(c));
        }

        this.setState({ 
            dashboard: db
        });
    }
        
    loadData() {
        let pars={
            days: this.DAYS
        }
        BackendService.call("analysis/wsPrebookErrorsAnalytics",pars).then((s) => {
            let c=JSON.parse(s);
            console.log("raw data",c);
            this.dataLoaded(c.Records.Entities);
            this.loadTopRecords();
        });
    }

    prepareDimensionsAndGroups() {          
        this.state.crossfilter.createBasicDimension("date","Date",true);
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Preparing dimension '" + fc + "' on '" + Charts.keyToField(fc) + "'");
            this.state.crossfilter.createBasicDimension(fc,Charts.keyToField(fc),true);
        }

        if(this.state.showBottoms) {
            for(let fc of this.state.dashboardConfiguration.FilterCharts) {
                console.log("Computing top " + this.TOPS + " on '" + fc + "'");
                this.state.crossfilter.computeTops(fc,this.TOPS,this.state.analysisField,true);
            }
        }        
    }

    feedDonut(key) {
        console.log("feedDonut",key);
        let cf=this.state.crossfilter;
        let data=cf.topValuesToSerie(key,this.TOPS,this.state.analysisField,this.state.dashboard.showBottoms);

        let db=this.state.dashboard;   
        db.charts[key].series=data.series;
        let opts={}
        if(db.charts[key].options)
            opts=Object.assign({}, db.charts[key].options);
        opts.labels=data.labels;
        console.log("feedDonut",key,data,opts);
        db.charts[key].options=opts;
    }

    computeChartData() {      
        console.log("--- computeChartData");
        let db=this.state.dashboard;   
        let cf=this.state.crossfilter; 

        let errorsPerDate=[];
        for(let m=1;m<=30;m++)
            errorsPerDate.push(0);
        let reduced=cf.groups.date.reduceSum(i => i[this.state.analysisField]);
        reduced.all().forEach((d,i) => {
            console.warn(d,i);
            errorsPerDate[i]=d.value;
        });
        let newSeries=[
            {   
                name: "Value",
                data: errorsPerDate 
            }
        ];
        db.charts.date.series=newSeries;
        console.log("Series for date",newSeries);
        
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Computing data for filter chart '" + fc + "'");
            this.feedDonut(fc);
        }
    }

    expandDetail(e,evt) {
        console.log("e",e);
        this.setState({
            detailDialogShown: true,
            recordToExpand: e
        })
    }

    hideDetails() {
        this.setState({
            detailDialogShown: false,
            recordToExpand: null
        })
    }

    loadTopRecords(sortMode) {
        if(!sortMode) sortMode=this.state.topRecordsSorting;
        this.setState({
            topRecords: null,
            selectedArticle: null,
            topRecordsSorting: sortMode
        })
        
        let pars={
        }

        let activeFilters=[];
        for(var dk in this.state.crossfilter.filters) {
            let fdim=this.state.crossfilter.activeFilters(dk);
            if(fdim) {
                activeFilters.push(Charts.keyToField(dk));
                
                let includes=[];
                let ip=0;
                let ddk=dk;
                fdim.forEach(e => {
                    if(e===this.state.crossfilter.getLabel_Others()) return;
                    let ev=e;
                    pars[Charts.keyToField(ddk) + "_i_" + ip]=ev;
                    includes.push(ev);
                    ip++;
                });

                let im=0;
                fdim.forEach(e => {
                    if(e!==this.state.crossfilter.getLabel_Others()) return;
                    this.state.crossfilter.topRecords[ddk].forEach(s => {
                        if(includes.indexOf(s)>=0) return;
                        pars[Charts.keyToField(ddk) + "_e_" + im]=s;
                        im++;
                    });
                });
            }
        }
        pars["ActiveFilters"]=activeFilters.join(',');
        pars["days"]=this.DAYS;

        BackendService.call("analysis/wsPrebookErrorsRecords",pars).then((s) => {
            let c=JSON.parse(s);
            console.log("top records",c);
            this.setState({
                topRecords: c.Records.Entities
            })
        });
    }

    filterChanged(key,sel) {        
        this.feedDonut("date");
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Computing data for filter chart '" + fc + "'");
            this.feedDonut(fc);
        }
        this.computeChartData();
        this.loadTopRecords();
    }

    getTopSorting() {
        let res=null;
        this.topRecordsSortings.forEach(e => {
            if(e.value==this.state.topRecordsSorting) res=e;
        });
        return res;
    }

    charts() {
        let topLbl=" (top " + this.TOPS + ")";

        let topRecords=[];
        if(this.state.topRecords) {
            let currentDate=null;
            topRecords=this.state.topRecords.map((e,i) => {
                let addDate=e.Date != currentDate;
                currentDate=e.Date;
                return (
                    <tbody key={i} className="hotel clickable" onClick={(evt) => this.expandDetail(e,evt)}>
                        { addDate &&
                            <tr>                            
                                <td colSpan={2}>
                                    <div style={{fontWeight:'bold',borderBottom:'1px solid #ccc'}}>{e.Date}</div>
                                </td>
                            </tr>
                        }
                        <tr>                            
                            <td>
                                <div className="hotel-name"><b>{e.Username}</b> - {e.Hotel} ({e.Contract})</div>
                                <div className="description">{e.Ts} : <b>{e.Error}</b></div>
                            </td>
                        </tr>
                    </tbody>
                );
            });
        }

        let fcharts=[];
        if(this.state.dashboard) {
            for(let fc of this.state.dashboardConfiguration.FilterCharts) {
                fcharts.push(
                    <div key={fc} style={{display:'inline-block',marginRight:'10px'}}>
                        <ChartArea title={"On " + Charts.keyToLabel(fc) + topLbl} 
                                        onSearch={() => this.showFilterSearch({ label: Charts.keyToLabel(fc),value: fc}) }>
                            <Chart 
                                options={this.state.dashboard.charts[fc].options} 
                                series={this.state.dashboard.charts[fc].series}
                                type="donut" width="350"
                                />
                        </ChartArea>
                    </div>
                );
            }
        }

        let tsSortItems=this.topRecordsSortings.map((s) => {
            return (
                <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
            )
        });

        return (
            <div className="charts-container" style={{flexDirection:"column"}}>
                <Dialog open={this.state.detailDialogShown} maxWidth="lg" fullWidth={true} className="filter-dialog">
                    <DialogTitle id="customized-dialog-title">Error detail</DialogTitle>
                    <DialogContent>
                        { this.state.recordToExpand &&
                            <div className="prebook_details">
                                <div>
                                    <label>Record ids in trace table</label>: {this.state.recordToExpand.Id}, {this.state.recordToExpand.Id2}
                                </div>
                                <div>
                                    <label>Tour operator</label>:  {this.state.recordToExpand.Username} ({this.state.recordToExpand.IdTourOperator})
                                    { this.state.recordToExpand.CallUsername != this.state.recordToExpand.Username &&
                                        <span> from <b>{this.state.recordToExpand.CallUsername}</b></span>
                                    }
                                </div>
                                <div>
                                    <label>Product</label>: {this.state.recordToExpand.Contract} - {this.state.recordToExpand.Offer} - {this.state.recordToExpand.Hotel}
                                </div>
                                <div>
                                    <label>Parameters</label>: 
                                    <pre>{this.state.recordToExpand.Parameters}</pre>
                                </div>
                                <div>
                                    <label>Error category</label>: {this.state.recordToExpand.Error}
                                </div>
                                <div>
                                    <label>Error trace</label>: <br/>
                                    <pre>{this.state.recordToExpand.ErrorTrace}</pre>
                                </div>
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="warning" onClick={() => this.hideDetails() }><Clear/> Close</Button>
                    </DialogActions>
                </Dialog>

                <div style={{display:"flex"}}>
                    <div>
                        <ChartArea style={{width:'1140px'}} title="On call date">
                            <div className="inline-chart">
                                <Chart 
                                    options={this.state.dashboard.charts.date.options} 
                                    series={this.state.dashboard.charts.date.series}
                                    type="bar" width="1100" height="200"
                                    />
                            </div>
                        </ChartArea>
                        <div style={{verticalAlign:'top',width:'1200px'}}>
                            {fcharts}
                        </div>
                    </div>
                    <div style={{flexGrow:2}}>
                        <div className="chart-area" style={{width:'95%'}}>
                            <div className="chart-title">
                                {"Details (top 50)"}
                                <div onClick={()=>this.exportTableToExcel('topsellers-table','top_records')} className="btn-2-excel link" style={{float:"right"}}>
                                    <TextSnippetIcon />
                                </div>
                            </div>
                            <div>
                                { !this.state.topRecords &&
                                    <Loading message="Loading details..." />
                                }
                                { this.state.topRecords &&
                                    <div>
                                        <div style={{borderBottom:'1px solid #ddd',paddingBottom:'4px'}}>
                                            <Select size="small" onChange={(e) => this.loadTopRecords(e.target.value)} value={this.state.topRecordsSorting} >
                                                {tsSortItems}
                                            </Select>
                                        </div>
                                        <div className="top-sellers articles compact" style={{height:'700px',overflow:'scroll'}}>
                                            <table id="topsellers-table">
                                                <tbody>
                                                    {topRecords}
                                                </tbody>
                                            </table>                            
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>    
                </div>                                 
            </div>
        );
    }

}
